import React, { useState, useEffect } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import tmdbConfigs from "../api/tmdb.config";
import CircularRate from "./CircularRate";
import { useSelector } from "react-redux";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { routesGen } from "./route";

const MediaItem = ({ media, mediaType }) => {
    const { listFavorites } = useSelector((state) => state.user) || [];

    const [title, setTitle] = useState("");
    const [posterPath, setPosterPath] = useState("");
    const [releaseDate, setReleaseDate] = useState("");
    const [rate, setRate] = useState(null);
    const [genres, setGenres] = useState([]);
    const [releaseYear, setReleaseYear] = useState("");

    useEffect(() => {
        setTitle(media.title || media.name || media.mediaTitle);
        setPosterPath(tmdbConfigs.posterPath(media.poster_path || media.backdrop_path || media.mediaPoster || media.profile_path));

        if (mediaType === tmdbConfigs.mediaType.movie) {
            setReleaseDate(media.release_date && media.release_date.split("-")[0]);
        } else {
            setReleaseDate(media.first_air_date && media.first_air_date.split("-")[0]);
        }

        setRate(media.vote_average || media.mediaRate);

        // Check if genres are nested within another property of the media object
        const mediaGenres = media.genres || media.genre_ids || [];

        // Assuming genres are provided as an array of objects with a name property
        const formattedGenres = mediaGenres.map(genre => genre.name || genre);

        setGenres(formattedGenres);
        setReleaseYear(media.release_date ? media.release_date.split("-")[0] : "");
    }, [media, mediaType]);

    const uiConfigs = {
        style: {
            backgroundImage: (imgPath) => ({
                position: "relative",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundColor: "darkgrey",
                backgroundImage: `url(${imgPath})`
            })
        }
    };

    return (
        <Link to={mediaType !== "people" ? routesGen.mediaDetail(mediaType, media.mediaId || media.id) : `/person/${media.id}`}>
            <Box sx={{
                ...uiConfigs.style.backgroundImage(posterPath),
                paddingTop: "120%",
                "&:hover .media-info": { opacity: 1, bottom: 0 },
                "&:hover .media-back-drop, &:hover .media-play-btn": { opacity: 1 },
                color: "primary.contrastText"
            }}>
                {mediaType !== "people" && (
                    <>
                        <Box className="media-back-drop" sx={{
                            opacity: { xs: 1, md: 0 },
                            transition: "all 0.3s ease",
                            width: "100%",
                            height: "100%",
                            position: "absolute",
                            top: 0,
                            left: 0,
                            backgroundImage: "linear-gradient(to top, rgba(0,0,0,1), rgba(0,0,0,0))"
                        }} />
                        <Button
                            className="media-play-btn"
                            variant="contained"
                            startIcon={<PlayArrowIcon />}
                            sx={{
                                display: { xs: "none", md: "flex" },
                                opacity: 0,
                                transition: "all 0.3s ease",
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                "& .MuiButton-startIcon": { marginRight: "-4px" }
                            }}
                        />
                        <Box
                            className="media-info"
                            sx={{
                                transition: "all 0.3s ease",
                                opacity: { xs: 1, md: 0 },
                                position: "absolute",
                                bottom: { xs: 0, md: "-20px" },
                                width: "100%",
                                height: "max-content",
                                boxSizing: "border-box",
                                padding: { xs: "10px", md: "2rem 1rem" }
                            }}
                        >
                            <Stack spacing={{ xs: 1, md: 2 }}>
                                {rate && <CircularRate value={rate} />}
                                <Typography>{releaseDate}</Typography>
                                <Typography variant="body1" fontWeight="700" sx={{ fontSize: "1rem" }}>{title}</Typography>
                                <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>Release Year: {releaseYear}</Typography>
                            </Stack>
                            {/*{genres.length > 0 && (*/}
                            {/*    <>*/}
                            {/*        <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>Genres:</Typography>*/}
                            {/*        {genres.map((genre) => (*/}
                            {/*            <Typography key={genre.id} variant="body2" sx={{ fontSize: "0.8rem" }}>{genre.name}</Typography>*/}
                            {/*        ))}*/}
                            {/*    </>*/}
                            {/*)}*/}


                        </Box>
                    </>
                )}
                {mediaType === "people" && (
                    <Box sx={{
                        position: "absolute",
                        width: "100%",
                        height: "max-content",
                        bottom: 0,
                        padding: "10px",
                        backgroundColor: "rgba(0,0,0,0.6)"
                    }}>
                        <Typography>{media.name}</Typography>
                    </Box>
                )}
            </Box>
        </Link>
    );
};

export default MediaItem;
